import React from 'react';
import { Row, Col } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';

class Content55 extends React.PureComponent {
  getChildren = (data) =>
    data.map((item, i) => {
      ['title', 'img', 'content'].forEach((key) => delete item[key]);
      return (
        <li key={item.name} className={item.className}>
          {item.titlewrapper.children.map(getChildrenToRender)}
        </li>
      );
    });

  getBlockChildren = (data) =>
    data.map((item, i) => {
      const children = item.children;
      const ulChildren = this.getChildren(children.block.children);
      if (i % 2) {
        return (
          <Col key={i.toString()} {...item} className="icon-right">
            <ul key="ul" {...children.block}>
              {ulChildren}
            </ul>
          </Col>
        );
      }
      return (
        <Col key={i.toString()} {...item} className="icon-left">
          <ul key="ul" {...children.block}>
            {ulChildren}
          </ul>
        </Col>
      );
    });

  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    const listChildren = this.getBlockChildren(dataSource.block.children);
    return (
      <div {...props} {...dataSource.wrapper}>
        <div {...dataSource.page}>
          <div {...dataSource.bg}>
            <img src={dataSource.bg.children} width="100%" alt="img" />
          </div>
          <div key="title" {...dataSource.titleWrapper}>
            {dataSource.titleWrapper.children.map(getChildrenToRender)}
          </div>
          <Row key="block" {...dataSource.block}>
            {listChildren}
          </Row>
        </div>
      </div>
    );
  }
}

export default Content55;
